import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { LoginComponent } from './components/login/login.component';
import { ScheduleCallComponent } from './components/schedule-call/schedule-call.component';
import { ConfirmModalComponent } from './dialogue/confirm-modal/confirm-modal.component';
import { EditCompanyComponent } from './components/edit-company/edit-company.component';
import { NgSelectModule } from '@ng-select/ng-select'
import { NgbAlertModule, NgbDatepickerModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from './components/pagination/pagination.component';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { SiteDetailsComponent } from './components/site-details/site-details.component';
import { SiteAssumptionsComponent } from './components/site-assumptions/site-assumptions.component';
import { FilterRecommendationGraphComponent } from '../modules/filter-recommendation-graph/filter-recommendation-graph.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgChartsModule } from 'ng2-charts';
import { DigitShuffleComponent } from './components/digit-shuffle/digit-shuffle.component';
import {ContactComponent} from './components/contact-form/contact-form.component';

@NgModule({
  declarations: [
    LoginComponent,
    ScheduleCallComponent,
    ConfirmModalComponent,
    EditCompanyComponent,
    PaginationComponent,
    CapitalizePipe,
    SiteDetailsComponent,
    SiteAssumptionsComponent,
    FilterRecommendationGraphComponent,
    DigitShuffleComponent,
    ContactComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    NgbAlertModule,
    NgxSliderModule,
    NgbPaginationModule,
    NgChartsModule
  ],
  exports: [
    LoginComponent,
    ScheduleCallComponent,
    ConfirmModalComponent,
    EditCompanyComponent,
    PaginationComponent,
    SiteDetailsComponent,
    NgSelectModule,
    NgbPaginationModule,
    CapitalizePipe,
    SiteAssumptionsComponent,
    FilterRecommendationGraphComponent,
    NgxSliderModule,
    DigitShuffleComponent,
    ContactComponent
  ]
})
export class SharedModule { }
